import React, { PureComponent } from 'react'
import { withPrefix } from 'gatsby-link'
import Modal from 'react-modal'
import ReactDOM from 'react-dom';
import './ModalCloudDetail.css'
import ShareButtons from './../ShareButtons'

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 1001,
  backgroundColor: 'red',
  // backgroundColor: '#000000d1',
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const contentStyle = {
  position: 'relative',
  top: 'unset',
  left: 'unset',
  right: 'unset',
  bottom: 'unset',
  backgroundColor: 'transparent',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderColor: 'transparent',
}


class ModalCloudDetail extends PureComponent {
  componentDidMount() {
    if (this.props.isOpen) {
      this.listenKeys()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isOpen !== nextProps.isOpen) {
      if (nextProps.isOpen) {
        this.listenKeys()
      } else {
        this.unlistenKeys()
      }
    }
  }

  componentWillUnmount() {
    if (this.props.isOpen) {
      this.unlistenKeys()
    }
  }

  listenKeys = () => {
    window.addEventListener('keydown', this.handleKey)
  }

  unlistenKeys = () => {
    window.removeEventListener('keydown', this.handleKey)
  }

  handleKey = e => {
    if (e.key === 'ArrowRight' && this.props.hasNext) {
      this.props.goNext()
    } else if (e.key === 'ArrowLeft' && this.props.hasPrev) {
      this.props.goPrev()
    }
  }

  render () {
      const { cloud,
              isOpen,
              onRequestClose,
              goNext,
              goPrev,
              hasNext,
              twitterShareLink,
              facebookShareLink,
              googlePlusShareLink,
              downloadClick,
              hasPrev } = this.props
      return (
        <Modal
          isOpen={isOpen}
          onRequestClose={onRequestClose}
          style={{ overlay: modalOverlayStyle, content: contentStyle }}
        >
          {cloud && <div className="mod-cloud-detail-container">
            <div>
              <i
                className={'fa fa-times fa-2x close-modal'}
                aria-hidden="true"
                onClick={onRequestClose}
              />
              <i
                className={`fa fa-caret-left fa-3x arrow-btn mr-2 modal-arrow-left ${!hasPrev && `arrow-disabled`}`}
                aria-hidden="true"
                onClick={hasPrev ? goPrev : undefined}
              />
              <img src={withPrefix(cloud.image)} className="mod-cloud-detail-img" />
              <i
                className={`fa fa-caret-right fa-3x arrow-btn ml-2 modal-arrow-right ${!hasNext && `arrow-disabled`}`}
                aria-hidden="true"
                onClick={hasNext ? goNext : undefined}
              />
            </div>
            <div className="mod-cloud-page-text p-3">
               <h5 className="mb-0 mod-cloud-code">DAILYCLOUD {cloud.name}</h5>
               <div>
                 <small className="text-info">Created {cloud.date}</small>
                 <hr className='mod-cloud-detail-hr' />
                 <ShareButtons
                   twitterShareLink={twitterShareLink}
                   facebookShareLink={facebookShareLink}
                   googlePlusShareLink={googlePlusShareLink}
                   downloadClick={downloadClick}
                 />
               </div>
             </div>
          </div>}
        </Modal>
    )
  }
}

export default ModalCloudDetail



// WEBPACK FOOTER //
// ./src/components/ModalCloudDetail/index.js